/* global axios */
import ApiClient from './ApiClient';

class KnowledgesAPI extends ApiClient {
  constructor() {
    super('llm_rags', { accountScoped: true });
  }

  // knowledge CRUD
  createKnowledge(payloadBody) {
    return axios.post(`${this.url}`, payloadBody);
  }

  getKnowledgeList(params = {}) {
    return axios.get(`${this.url}`, {
      params: {
        ...params,
      },
    });
  }

  getKnowledgesFilterList(params = {}) {
    const { payload, ...restParams } = params;
    return axios.post(
      `${this.url}/filter`,
      { payload },
      {
        params: {
          ...restParams,
        },
      }
    );
  }

  updateKnowledgeById(knowledge_id, payload) {
    return axios.patch(`${this.url}/${knowledge_id}`, payload);
  }

  deleteKnowledgeById(knowledge_id) {
    return axios.delete(`${this.url}/${knowledge_id}`);
  }

  getAllKnowledgeList() {
    return axios.get(`${this.url}/lists`);
  }
}

export default new KnowledgesAPI();
